import { supabase } from '@/lib/supabase';
import { logger } from '@/lib/logger';
import { getSupabaseDbError } from '@/lib/errors';
import type { FriendlyError } from '@/lib/errors';
import { captureFriendlyError } from '@/lib/sentry';
import type {
  NotificationPrefs,
  NotificationPrefsUpdate,
} from '@/types/notifications';

export async function fetchNotificationPrefs(
  userId: string
): Promise<NotificationPrefs | null> {
  const { data, error } = await supabase
    .from('notification_preferences')
    .select('*')
    .eq('user_id', userId)
    .single();

  if (error) {
    logger.error('Error fetching notification prefs', error, { userId });
    return null;
  }

  return data as NotificationPrefs;
}

export async function updateNotificationPrefs(
  userId: string,
  prefs: NotificationPrefsUpdate
): Promise<{ success: boolean; error?: FriendlyError }> {
  const { error } = await supabase
    .from('notification_preferences')
    .update({
      ...prefs,
      updated_at: new Date().toISOString(),
    })
    .eq('user_id', userId);

  if (error) {
    logger.error('Error updating notification prefs', error, { userId });
    const friendly = getSupabaseDbError(error.code || 'db_update_failed');
    captureFriendlyError(error, friendly, { userId });
    return { success: false, error: friendly };
  }

  return { success: true };
}
